export const ORDER_ATTRIBUTION = 'order_attribution';
export const ICE_CHECKOUT = 'ice_checkout';
export const EMAIL_SUPPORT_EXTENDED_DELIVERY_FAILURE_STATUSES = 'support_extended_delivery_failure_statuses';
export const EXP_ASSOCIATE_SCORECARD_REDESIGN = 'expanded_associate_scorecard_redesign';
export const CLIENT_INFORMATION_FROM_UCA = 'client_information_from_uca';
export const ONLINE_CART_API_V2 = 'online_cart_api_v2';
export const BG_UCA_ACCOUNT_CREATION_FLOW = 'bg_uca_account_creation_flow';
export const PRODUCT_RESERVATIONS = 'product_reservations';
export const VIEWING_PRODUCT_RESERVATIONS = 'viewing_product_reservations';
export const ATTACHMENTS_PAGE = 'attachments_page';
export const TAKES_LP_OVERRIDE = 'takes_lp_override';
export const CLIENT_PROFILE_FROM_CONVERSATION = 'client_profile_link_from_messages';
export const ATTRIBUTION_LINK_CLIPBOARD_COPY = 'attribution_link_clipboard_copy';
export const ADDITIONAL_PINS_IN_CART = 'additional_pins_in_cart';
export const DIGITAL_CLIENT_LEAD = 'sales_associate_match_notification';
export const VOIDS_FOR_ORDER_DETAILS_PAGE = 'voids_order_details_page';
export const STANLEY_ELIGIBLE_CLIENT_GROUP = 'stanley_eligible_client_group';
export const MANAGER_PRODUCT_RESERVATIONS = 'manager-product-reservations';
export const RESORT_22_LOOK_CATEGORY = 'resort_22_look_category';
export const DEFAULT_CLIENT_EMAIL_SEARCH = 'client_search_email_default_option';
export const PRODUCT_SHARE_COMISSION_ATTRIBUTION = 'product_share_commision_attribution';
export const PURCHASE_INSIGHTS = 'purchase_insights';
export const TARGETED_CLIENT_LIST = 'targeted_client_list';
export const DISABLE_EMAIL_RECIPIENTS_LIMIT = 'disable_email_recipient_limit';
export const STORE_SENDS_RECEIPTS = 'store_sends_receipts';
export const AUTO_POPULATE_DEFAULT_EMAIL_ADDRESS = 'auto_populate_default_email_address';
export const SEARCH_ALL_RESERVATIONS = 'search_all_reservations';
export const INSTORE_EXPANDED_PAYMENT_OPTIONS = 'instore_expanded_payment_options';
export const INSTORE_CHECKOUT_REFACTOR = 'instore_checkout_refactor';
export const NOTIFICATION_PAGINATION = 'notification_pagination';
export const CLIENT_ONLINE_BAG_TAB = 'client_online_bag_tab';
export const STORE_MAPPING_ACCESS = 'store_mapping_sa_access';
export const INSTORE_GIFT_CARDS = 'instore_gift_cards';
export const NM_ASSOCIATE_RESERVATIONS = 'nm_associate_reservations';
export const MY_CLIENTS_TAB = 'my_clients_tab';
export const MY_CLIENTS_TAB_ALL_NM_SA = 'my_clients_tab_all_nm_sa';
export const NEW_EDIT_CONTENT = 'new_edit_content';
export const TRACKING_METRICS_PRODUCT_LOOK_TEXT_SHARE = 'tracking-metrics-product-look-text-share';
export const MY_CLIENTS_ESTABLISHED_GROUP = 'my-clients-established-group';
export const MY_CLIENTS_DEVELOPING_GROUP = 'my-clients-developing-group';
export const MY_CLIENTS_DCL_GROUP = 'my-clients-dcl-group';
export const MY_CLIENTS_NMVIP_GROUP = 'nmvip_group';
export const MY_CLIENTS_RELATIONSHIP_GROUP = 'my-clients-relationship-group';
export const MY_CLIENTS_FIRST_TRIP_GROUP = 'my-clients-first-trip-group';
export const MY_CLIENTS_TWO_TRIPS_GROUP = 'two_trips_group';
export const MY_CHAT_CLIENTS_GROUP = 'chat_clients_group';
export const MY_EDITS_ENHANCEMENT = 'edits_enhancements';
export const DCL_MATCH_DATE = 'dcl_match_date';
export const ECID_LOOK_AND_EDIT = 'ecid_look_and_edit';
export const ECID_SINGLE_PRODUCT_SHARE = 'ecid_single_product_share';
export const EMAIL_EDIT_SHARE_TRACKING = 'email-edit-share-tracking';
export const CLIENT_PROFILE_REDESIGN = 'client_profile_redesign';
export const RENAME_CHAT_MESSAGE = 'rename_chat_message';
export const COLLECTION_STYLEBOARD_ENABLED = 'collection_category_styleboard';
export const PRODUCT_SPOTLIGHT_LANDING_PAGE = 'product_spotlight_landing_page';
export const ONE_APP_ICON_UPDATE = 'one_app_icon_update';
export const SKU_TRACKER_PRODUCT_SHARE_VIA_CHAT = 'sku-tracker-product-share-via-chat';
export const PAYMENT_SLED_INTEGRATION = 'payment_sled_integration';
export const EMAIL_EDIT_ATTACHMENT = 'email-edit-attachment';
export const ENABLE_CUSTOM_SPLIT_PERCENTAGES = 'enable_custom_split_percentages';
export const EMAIL_TEMPLATE_HEADER_CATEGORIES = 'email_template_header_categories';
export const EDITS_HOLIDAY_CATEGORY = 'edits_holiday_category';
export const HOLIDAY_LOOK_CATEGORY = 'holiday_look_category';
export const PDP_SALE_ADORNMENT = 'pdp_sale_adornment';
export const DLE_READ_ONLY = 'dle_read_only';
export const ENABLE_GIFT_RECEIPT = 'gift_receipt';
export const ENABLE_SPLIT_GIFT_RECEIPT = 'split_gift_receipt';
export const EXPANDED_PRODUCT_RESERVATIONS = 'expanded_product_reservations';
export const NM_APP_CLIENT_FILTER = 'nm_app_client_filter';
export const EDIT_BG_TAB = 'edit_bg_tab';
export const EDITS_STYLEBOARD_PADDING = 'edits_styleboard_padding';
export const MARKETING_PILLS_CC_AND_GLOBAL_SEARCH = 'marketing_pills_cc_and_global_search';
export const EXPANDED_CLIENT_CONNECTS_MANAGER_VIEW = 'expanded_client_connects_manager_view';
export const GIFT_RETURN = 'gift_return';
export const RETURN_DATE = 'return_date';
export const MOBILE_POS = 'mobile_pos';
export const BG_CLICK_THROUGH = 'bg_click_through';
export const REFRESH_BG_CATEGORY = 'refresh_bg_category';
export const ADD_NEW_ADDRESS = 'add_new_address';
export const DISABLE_UNAVAILABLE_CONTACT_OPTIONS = 'disable_unavailable_contact_options';
export const SA_IMAGE_UPLOAD = 'sa_image_upload';
export const BG_FARFETCH = 'bg_farfetch';
export const VERTEX_O = 'vertex_o_series';
export const NO_LIMIT_LOOK_SHARE = 'no_limit_look_share';
export const SKU_TRACKER_EXPANDED_SMS = 'sku_tracker_expanded_sms';
export const ORDER_SUBMIT_FAILURE = 'order_submit_failure';
export const SM_GROUP_MIGRATION = 'sm_group_migration';
export const MAO_MPOS = 'mao_mpos';
export const MAO_ORDERS = 'mao_orders';
export const MAO_INVENTORY = 'mao_inventory';
